const discountCode = localStorage.getItem("klub-discount-code");
if (document.querySelector('#sidebar-cart') && localStorage.getItem("klub-discount-code")) {
	applyDiscountCode(discountCode);
	window.addEventListener('rendered-cart', () => {
		setTimeout(async () => {
			applyDiscountCode(discountCode);
		}, 1000);
	});
}

export function applyDiscountCode(discountCode) {
	const sidebar = document.querySelector('#sidebar-cart');
	const discountInput = sidebar.querySelector('.js-form-discount');
	if (!discountInput) return;
	const originalDiscountCode = discountInput.getAttribute('original-discount-value');
	if (originalDiscountCode) discountInput.setAttribute('value', `${originalDiscountCode},${discountCode}`);
	else discountInput.setAttribute('value', `${discountCode}`)
}

